import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { Button, Form, Header, Icon, Input, Select, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from "semantic-ui-react";
import { toast } from 'react-toastify';
import { useStore } from "../../../app/stores/store";
import { dropTitleCode } from "../../../app/models/Restoration";
import {InventoryList, InventoryListDetails} from "../../../app/models/TitleCreate";
interface csvFields {
reel_Name:string;
start_Frame:number;
end_Frame:number;
}
const RestorationInventory = () => {
  const { RestorationStore} = useStore();
  const [csvData, setCsvData] = useState<csvFields[]>([]);
  const [existingReelData, setExistingReelData] = useState<InventoryListDetails[]>([]);
  const [friendOptions, setFriendOptions] = useState<dropTitleCode[]>([]);
  const [titleCode,setTitleCode]=useState<string>('');
  const [selectedTitleCode, setSelectedTitleCode] = useState<string[]>([]);
  const[reelEditEnable,setReelEditEnable]=useState<boolean>(false);
  const [editInvenotory, setEditInvenotory] = useState<InventoryListDetails|null>(null);
  
  const csvHeaders = [
        { label: 'Reel Name', key: 'reel_Name' },
        { label: 'Start Frame', key: 'start_Frame' },
        { label: 'End Frame', key: 'end_Frame' }
      ];  
  
  const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const reader = new FileReader();
    setCsvData([]);
    const file = event.target.files?.[0];
    if (!file) return;
    if(file.size > 1*1024*1024){
      toast.error("File size exceeds limit!");
      return;
    }
    reader.onload = (e) => {
      const text = e.target?.result as string;
      const rows = text.split('\n');
      const filteredData = rows.slice(1).filter((item) => item.trim() !== '');
      const existingReelNames = new Set(csvData.map(item => item.reel_Name));
      const parsedData: csvFields[] = filteredData.map((row) => {
        const [reel_Name, start_Frame, end_Frame] = row
          .replace(/\r/g, '')
          .split(',')
          .map((item) => item.trim());
          if (existingReelNames.has(reel_Name)) {
            toast.warning(`Please Check Reel Name Duplicates  ${reel_Name}`);
            return null;
          }
          existingReelNames.add(reel_Name);
        return {
          reel_Name,
          start_Frame: parseInt(start_Frame, 10),
          end_Frame: parseInt(end_Frame, 10),
        };
      }).filter((item): item is csvFields => item !== null);;
      setCsvData(prevData => [...prevData, ...parsedData]);
    };
    reader.readAsText(file);
    event.target.value = '';
  };
  const TitleCodeAPI=async (title:string) =>
  {
    await RestorationStore.TitleReelInventoryDetails(title);
    const ExistingReel=RestorationStore.InventoryListDetails;
    setExistingReelData(ExistingReel);
  }
  const setDD = (_e: any, data: any) => {
    setSelectedTitleCode(data.value);
    TitleCodeAPI(data.value);
    setTitleCode(data.value);
  };
  const Titlecode = async()=>{
    await RestorationStore.getLiveTitleCode();
    const projectCode = RestorationStore.dropTitleCode;
    setFriendOptions(projectCode);
  }
  const DeleteInventory = async (data:InventoryListDetails) =>{
    await RestorationStore.TitleReelInventoryRemoved(data.id);
    TitleCodeAPI(data.title_Code);
  }
  const addReel=async ()=>{
    const input=await RestorationStore.TitleInformation(titleCode)
    //const input=datas.response;
    const updatedInventoryData: InventoryList[] = csvData.map(data => ({
      title_Code: titleCode,  // Update with your title_Code
      reel_Name: data.reel_Name,
      start_Frame: data.start_Frame,
      end_Frame: data.end_Frame,
    }));
    await RestorationStore.CreateTitleReelInventory(input,updatedInventoryData);
    TitleCodeAPI(titleCode);
  }
  const onClickEdit=async(Editdata:any)=>{
    setReelEditEnable(true);
    const inventoryUpdate:InventoryListDetails={
      id: Editdata.id,
    itemID: Editdata.itemID,
    title_Code: Editdata.title_Code,
    reel_Name: Editdata.reel_Name,
    start_Frame:Editdata.start_Frame,
    end_Frame:Editdata.end_Frame,
    total_Frame:Editdata.total_Frame
    }
    setEditInvenotory(inventoryUpdate);
  }
  const onClickSubmitEdit=async()=>{
    if (!editInvenotory) {
      toast.error("editInvenotory is null. Cannot submit.");
      return;
    }
    if(editInvenotory.start_Frame > editInvenotory.end_Frame){
      toast.error("Please Enter Valid Frame Range");
      return;
    }
    try {
      await RestorationStore.TitleReelInventoryUpdate(editInvenotory);
      setReelEditEnable(false);
      TitleCodeAPI(editInvenotory.title_Code);
      toast.success("Inventory successfully updated!");
    } catch (error) {
      toast.error("An error occurred while updating the inventory.");
    }

  }
  useEffect( () => {
    Titlecode();
    //eslint-disable-next-line
  },[])
  return (
    <>
     <div className="title-wise-table">
     <Header>Manage Title Inventory</Header>
      <Form.Group widths="equal">
        <Form.Field style={{ display: 'flex' }}>
        <div className="tr-dropdown">
            <label>Title Code:</label>
            <Select
              placeholder="Select Title code"
              selection
              search
              clearable
              options={friendOptions}
              value={selectedTitleCode}
              onChange={(_event, data) => setDD(_event, data)}
            />

         {titleCode!=='' && (<>
        <label style={{ margin: '10px' }}>Upload Inventory </label>
          <Input type="file" onChange={handleFileUpload} />
          <CSVLink data={csvData} headers={csvHeaders} filename={'Inventory_Details.csv'}>
            <Icon
              style={{ marginTop: '5px', marginLeft: '40px' }}
              corner="bottom right"
              size="large"
              circular
              inverted
              color="teal"
              name="file excel outline"
            />
          </CSVLink>
          </>)}
          </div>
        </Form.Field>

      </Form.Group>
      { csvData.length !==0 && (
        <>
      <Header as='h4'>Upload Inventory Details</Header>
      <Table>
        <TableHeader>
        <TableRow>
        <TableCell >No Of Reel Upload : {csvData.length}</TableCell>
        </TableRow>
          <TableRow>
            <TableHeaderCell>Reel Name</TableHeaderCell>
            <TableHeaderCell>Start Frame</TableHeaderCell>
            <TableHeaderCell>End Frame</TableHeaderCell>
            <TableHeaderCell>Total Frame</TableHeaderCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {csvData.map((rowData, index) => (
            <TableRow key={index}>
              <TableCell>{rowData.reel_Name}</TableCell>
              <TableCell>{rowData.start_Frame}</TableCell>
              <TableCell>{rowData.end_Frame}</TableCell>
              <TableCell>{(rowData.end_Frame - rowData.start_Frame) + 1}</TableCell>
            </TableRow>
          ))}
          <TableRow>
          <TableCell colSpan={4} textAlign="right"> <b>Create Reel</b>  <Button basic color='green' icon='add square' onClick={addReel}/></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>)}
    {reelEditEnable && (
      <>
      <Header as='h4'>Edit Reel Details</Header>
      <Form>
      <Form.Group widths="equal">
            <Form.Field style={{ display: 'flex' }}>
              <label>Reel Name:</label>
              <Input value={editInvenotory?.reel_Name}  readOnly/>
            </Form.Field>
            <Form.Field style={{ display: 'flex' }}>
              <label>Start Frame:</label>
              <Input value={editInvenotory?.start_Frame} onChange={(e)=>setEditInvenotory((prev)=>{if (!prev) return null;return {...prev,start_Frame: parseInt(e.target.value) || 0};})}/>
            </Form.Field>
            <Form.Field style={{ display: 'flex' }}>
              <label>End Frame:</label>
              <Input value={editInvenotory?.end_Frame} onChange={(e)=>setEditInvenotory((prev)=>{if (!prev) return null;return {...prev,end_Frame: parseInt(e.target.value) || 0};})}/>
              </Form.Field>
            <Form.Field style={{ display: 'flex' }}>
              <label>Total Frame:</label>
              <Input value={(editInvenotory?.end_Frame ?? 0)- (editInvenotory?.start_Frame ?? 0) + 1 } readOnly/>
            </Form.Field>
            <Form.Field style={{ display: 'flex' }}>
            <Button onClick={onClickSubmitEdit} disabled={!editInvenotory || editInvenotory.start_Frame > editInvenotory.end_Frame}> Submit</Button>
            </Form.Field>

      </Form.Group>
      </Form>
    
      </>
      )}
      { existingReelData.length !==0 && (
        <>
      <Header>Inventory Details </Header>
      <Table>
        <TableHeader>
        <TableRow>
        <TableCell >No Of Reel Upload : {existingReelData.length}</TableCell>
        </TableRow>
          <TableRow>
            <TableHeaderCell>Reel Name</TableHeaderCell>
            <TableHeaderCell>Start Frame</TableHeaderCell>
            <TableHeaderCell>End Frame</TableHeaderCell>
            <TableHeaderCell>Total Frame</TableHeaderCell>
            <TableHeaderCell>Edit</TableHeaderCell>
            <TableHeaderCell>Delete</TableHeaderCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {existingReelData.map((rowData, index) => (
            <TableRow key={index}>
              <TableCell>{rowData.reel_Name}</TableCell>
              <TableCell>{rowData.start_Frame}</TableCell>
              <TableCell>{rowData.end_Frame}</TableCell>
              <TableCell>{rowData.total_Frame}</TableCell>
              <TableCell><Button basic color='yellow' icon='edit outline'  onClick={()=>{onClickEdit(rowData)}}/></TableCell>
              <TableCell><Button basic color='red' icon='trash alternate outline'  onClick={()=>{DeleteInventory(rowData)}}/></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>)}

    </div>
    </>
    
  )
}

export default RestorationInventory